import {Button, InputAdornment, Popover, TextField} from "@mui/material";
import {useState} from "react";

// the popover that edits an angle in degrees (a plan-angle label on the canvas opens
// it). Mirrors DimensionEditor without the lock: an angle is always user-set.
export function AngleEditor(props: {
    value: number;
    onDone: (deg: number) => void;
    onCancel: () => void;
}) {
    const [anchor, setAnchor] = useState<HTMLDivElement | null>(null);
    const [value, setValue] = useState(formatAngle(props.value));

    const submit = () => {
        const deg = parseFloat(value);
        if(isNaN(deg)) return;
        props.onDone(deg);
    };

    return (
        <>
            <div ref={setAnchor}></div>
            {anchor && <Popover anchorEl={anchor} open onClose={() => props.onCancel()}>
                <div style={{display: "flex", alignItems: "stretch"}}>
                    <TextField
                        onChange={e => setValue(e.currentTarget.value)}
                        onFocus={e => e.currentTarget.select()}
                        value={value}
                        onKeyDown={e => {
                            if(e.key === "Enter") submit();
                        }}
                        autoFocus
                        style={{minWidth: 30, width: 100}}
                        InputProps={{endAdornment: <InputAdornment position="end">°</InputAdornment>}}
                    />
                    <Button onClick={() => submit()} style={{height: "auto"}}>Done</Button>
                </div>
            </Popover>}
        </>
    );
}

// an angle for display, in degrees with up to one decimal. The canvas font has no
// degree sign, so canvas labels append the unit as text.
export function formatAngle(deg: number): string {
    const rounded = Math.round(deg * 10) / 10;
    return Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1);
}
